import { render, staticRenderFns } from "./MenuIndex.vue?vue&type=template&id=5a33c219&scoped=true"
import script from "./MenuIndex.vue?vue&type=script&lang=js"
export * from "./MenuIndex.vue?vue&type=script&lang=js"
import style0 from "./MenuIndex.vue?vue&type=style&index=0&id=5a33c219&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a33c219",
  null
  
)

export default component.exports